import React, {useEffect, useMemo, useState} from 'react';
import {ReactComponent as CorrectIcon} from '../../../../../../../assets/main/test/response/correct-order/correct.svg';
import {ReactComponent as WrongIcon} from '../../../../../../../assets/main/test/response/correct-order/wrong.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {
    incrementCorrectTestCount,
    resetCorrectTestCount
} from "features/model/slice/test/correct-test/correctTestSlice";
import {TestItem} from "features/model/slice/create-test/create-test-form/createTestForm";
import {TestImage} from "../../../../students-test/separate-test/separate-test-table/test-tabs/test-table/test-image/Test-image";


interface Answer {
    id: number;
    position: number;
    text: string;
}



interface CorrectOrderProps {
    testItem: TestItem;
    index: number;
}

interface AnswerStudent {
    id: number;
    position: number;
    text: string;
}

interface DragItemType {
    id: number;
    position: number;
    text: string;
}

export const CorrectOrder: React.FC<CorrectOrderProps> = React.memo(({ testItem, index }) => {
    const dispatch = useAppDispatch();
    const drag: any = useAppSelector((state) => state.testViewAnswerId.serverData?.data.result.drag) || {};


    const sortedAnswersId = [...testItem.answers].sort((a, b) => a.position - b.position);

    const questionKey = String(testItem.id);

    const isCorrectOrder = useMemo(() => {
        const answers = drag[questionKey];
        return answers && sortedAnswersId.every((sortedAnswer, index) => {
            const answer = answers[index];
            return answer && answer.id === sortedAnswer.id;
        });
    }, [drag, sortedAnswersId, questionKey]);

    const correctnessArray = useMemo(() => {
        const answers = drag[questionKey];
        return answers && sortedAnswersId.map((sortedAnswer, index) => {
            const answer = answers[index];
            return answer && answer.id === sortedAnswer.id ? 'correct' : 'incorrect';
        }) || [];
    }, [drag, sortedAnswersId, questionKey]);

    useEffect(() => {
        if (isCorrectOrder) {
            dispatch(incrementCorrectTestCount(1));
        }
    }, [isCorrectOrder, dispatch]);


    const containerClass = `test-descr-item answered ${isCorrectOrder ? '' : 'error'}`;

    return (
        <div className={containerClass}>
            <p className="h4 test-descr-title">
                <span className="index-num">{++index}</span>
                {testItem.questionTitle}
            </p>

            {testItem.tabType === 'imageType' && (
                <TestImage imageUrl={testItem.file?.path}/>
            )}

            <div className="drag-words-list disabled-drag">
                {Array.isArray(correctnessArray) &&
                    correctnessArray.map((correctness, innerIndex) => {
                        const answer = drag[questionKey][innerIndex];
                        return (
                            <span
                                className={`word word-padding ${correctness === 'correct' ? 'incorrect' : 'incorrect-answer'}`}
                                key={answer.id}
                            >
                                <span className="index">{testItem.answers.find(a => a.id === answer.id)?.position}.</span>
                                {answer.text}
                                {correctness === 'correct' ? <CorrectIcon /> : <WrongIcon />}
                            </span>
                        );
                    })
                }
            </div>
        </div>
    );
});


